<ng-container *ngIf="viewType=='MIN'">
  <div class="hpanel-693 margin-bottom-5-693 gs-widget-card"
    *ngIf="userType=='JOB_SEEKER'|| userType=='student'|| userType=='BENCH_RECRUITER'|| userType=='MANAGEMENT_TALENT_ACQUISITION'|| userType=='FREELANCE_RECRUITER'">
    <app-common-skeleton *ngIf="loadAPIcall" [countforView]="1" [NameOftheScreen]="'widgets'"></app-common-skeleton>

    <ng-container *ngIf="filterjob =='false'&&!loadAPIcall|| filterjob==undefined&&!loadAPIcall">
      <div class="panel-heading-693 hbuilt-693 widget-header-693 gs-widget-header">
        <span class="header-title-693">Jobs From Connections</span>
        <span class="refresh-icon-693" title="Refresh" (click)="refershJObs()">
          <ng-icon name="tablerRefresh"></ng-icon>
        </span>
      </div>
      <div class="panel-body-693 pad-10-693 widget-content-693 gs-widget-body">
          <ul class="profile-list-693">
            <ng-container *ngFor="let item of response | slice:0:3">
              <app-common-profile-info [userIdInput]="item.jobPostedBy" [page]="'JOBS'" [data]="item"
                (click)="redirect(item)" class="job-item-693">
                <ng-container headline1>
                  <span class="job-title-693">{{item.jobTitle}}</span>
                </ng-container>
                <p headline2 class="job-classification-693" [title]="item.jobClassification">{{item.jobClassification}}</p>
              </app-common-profile-info>
            </ng-container>
            
            <button class="gs-743-more-btn" type="button"
                    *ngIf="response?.length > 0"
                    (click)="modelopen(response,false,'')">
              View more →
            </button>
            
            <div class="gs-empty" *ngIf="!response || response.length === 0">
              <span class="gs-empty-icon"><ng-icon name="tablerSparkles"></ng-icon></span>
              <div class="gs-empty-title">No job suggestions yet</div>
              <div class="gs-empty-sub">Get connected with people to start seeing matches.</div>
            </div>
          </ul>
      </div>
    </ng-container>
  </div>
</ng-container>
<div class="margin-bottom-5 eyeicon-scroll-container" *ngIf="viewType=='MAX'"
 infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="2000" (scrolled)="onScrollDown()">

  <div class="panel-body cardw">
    <div class="row">
      <div class="col-12">
        <app-common-skeleton *ngIf="loadAPIcall" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>

        <div *ngIf="sugges!=null&& !loadAPIcall">
          <div class="col-md-12 padding-left-0 padding-right-5">
            <app-job-card [viewSize]="'large'" [JobData]="sugges"></app-job-card>
          </div>
        </div>
        <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="response?.length == 0 && !loadAPIcall">
          <div class="gs-empty">
            <span class="gs-empty-icon"><ng-icon name="tablerSparkles"></ng-icon></span>
            <div class="gs-empty-title">No suggestions yet</div>
            <div class="gs-empty-sub">Get connected with people to start seeing matches.</div>
          </div>
        </div>
        <div *ngIf="sugges==null&& !loadAPIcall">
          <div class="col-md-12 padding-left-0 padding-right-5"
            *ngFor="let item of response">
            <app-job-card [viewSize]="'large'" [JobData]="item" [From]="'JOBS_FROM_CONNECTION'"></app-job-card>

          </div>
        </div>
        <div class="col-sm-12 gs-end-of-list" *ngIf="stopScroll&&response.length>0" style="text-align: center;padding-top: 1rem;">
          <div class="col-sm-12">
            <!-- <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" >
              <path
                d="M15.9047 8.38142C16.2952 7.9909 16.9284 7.9909 17.3189 8.38142C17.7094 8.77195 17.7094 9.40511 17.3189 9.79564L12.0541 15.0592C11.079 16.0341 9.49854 16.0354 8.52183 15.062L6.70711 13.2535C6.31658 12.863 6.31658 12.2298 6.70711 11.8393C7.09763 11.4488 7.7308 11.4488 8.12132 11.8393L9.57698 13.2949C9.9675 13.6855 10.6007 13.6855 10.9912 13.2949L15.9047 8.38142Z"
                fill="#8B5CF6" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 20.9932C7.03321 20.9932 3.00683 16.9668 3.00683 12C3.00683 7.03321 7.03321 3.00683 12 3.00683C16.9668 3.00683 20.9932 7.03321 20.9932 12C20.9932 16.9668 16.9668 20.9932 12 20.9932Z"
                fill="#8B5CF6" />
            </svg> -->
            <ng-icon name="tablerCircleCheck"></ng-icon>

          </div>
          <div class="col-sm-12">
            <p class="biase">You've reached the bottom of the page</p>
          </div>
        </div>
        <!-- <div *ngIf="response === null&& !loadAPIcall|| response?.length === 0&&!loadAPIcall">
          <p appQueryDOM [response]="resultContent" class="empty-message-container"
            style="float: right; position: relative; top: 150%; right: 32rem; bottom: -4rem; font-size: x-large;">
            <img src='assets/images/empty-page-picture.png' alt="">
            <span id="EmptyMessage" style="margin-top:-30px;" class="empty-message">fetching jobs...
            </span>
          </p>
        </div> -->

      </div>


    </div>
  </div>


</div>
